<template>
  <CardSection :loading="isSavableStateLoading"
    :error="majorError"
    header-class="title-bar">
    <template #header>
      Edit Application Settings - Robocall Reduction
    </template>

    <template #body>
    <SubSection :sub-section-heading="'Configuration'" :sub-section-nav="subSectionNav">
      <template #body>
        <div class="tab-back">
        <SubSection>
          <template #body>
            <VeeForm v-if="robocallReduction" @submit="submitRobocallReduction"> 
              <RobocallReductionState :is-enabled="isEnabled" 
                @reload="reload" 
                :last_status_change="robocallReduction.status_changed_by_name" 
                :last_incoming_email_time="formatDateTimeET(robocallReduction.last_incoming_email_date_time)"
                :last_status_change_time="formatDateTimeET(robocallReduction.last_status_change_time)"
                :last_incoming_robocall_time="formatDateTimeET(robocallReduction.last_incoming_call_date_time)"/>
              <div class="inline-row">
                <div class="row">
                <div class="col sub-section-header">
                  <h4 class="m-0 h4">Robocall Reduction Settings</h4>
                </div>
              </div>
              <div class="row">
                <TextInput v-model="robocallReduction.config.aoc_robocall_number"
                  name="aoc_robocall_number"
                  label="AOC #"
                  rules="required|phone_number"
                  col-style="form-group-standard-column"
                />
                <TextInput v-model="robocallReduction.config.unos_robocall_number"
                  name="unos_robocall_number"
                  label="Incoming UNOS #"
                  rules="required|phone_number"
                  col-style="form-group-standard-column"
                />
              </div>
              <div class="row">
                <TextInput v-model="robocallReduction.config.issue_alert_email"
                  name="issue_alert_email"
                  label="Issue alert email"
                  rules="required|email"
                  col-style="form-group-standard-column"
                />
              </div>
              <div class="row align-items-center">
                <div class="col-lg-2 col-md-2">
                  <div class="form-check form-check-inline">
                    <input id="record_robocalls"
                      v-model="robocallReduction.config.record_robocalls"
                      class="form-check-input"
                      type="checkbox"
                      aria-labelledby="record_robocalls">
                    <label class="form-check-label" for="record_robocalls">Record Robocalls</label>
                  </div>
                </div>
                <TextInput v-model="robocallReduction.config.notification_batch_threshold"
                  name="notification_batch_threshold"
                  type="number"
                  label="Batch Threshold"
                  rules="required|min_value:1"
                  col-style="form-group-standard-column"
                />
              </div>

              <hr class="inline-row">

              <div class="row">
                <div class="col sub-section-header">
                  <h4 class="m-0 h4">Notification Settings</h4>
                </div>
              </div>

              <div class="notification-box">
                <h5>Coordinator Initial Offer Notification</h5>
                <div class="form-check form-check-inline mb-3">
                  <input id="coordinator_initial_enabled"
                    v-model="robocallReduction.config.coordinator_initial_enabled"
                    class="form-check-input"
                    type="checkbox"
                    aria-labelledby="coordinator_initial_enabled">
                  <label class="form-check-label" for="coordinator_initial_enabled">Enabled</label>
                </div>
                <div class="row">
                  <TextInput v-model="robocallReduction.config.stop_duration"
                    name="stop_duration"
                    type="number"
                    label="Regular Stop Duration"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                  <TextInput v-model="robocallReduction.config.resend_duration"
                    name="resend_duration"
                    type="number"
                    label="Regular Resend Interval"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                </div>
              </div>

              <div class="notification-box">
                <h5>Coordinator Expedited Offer Notification</h5>
                <div class="form-check form-check-inline mb-3">
                  <input id="coordinator_expedited_enabled"
                    v-model="robocallReduction.config.coordinator_expedited_enabled"
                    class="form-check-input"
                    type="checkbox"
                    aria-labelledby="coordinator_expedited_enabled">
                  <label class="form-check-label" for="coordinator_expedited_enabled">Enabled</label>
                </div>
                <div class="row">
                  <TextInput v-model="robocallReduction.config.expedited_stop_duration"
                    name="expedited_stop_duration"
                    type="number"
                    label="Expedited Stop Duration"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                  <TextInput v-model="robocallReduction.config.expedited_resend_duration"
                    name="expedited_resend_duration"
                    type="number"
                    label="Expedited Resend Interval"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                </div>
              </div>

              <div class="notification-box">
                <h5>Coordinator Primary Offer Notification</h5>
                <div class="form-check form-check-inline mb-3">
                  <input id="coordinator_primary_enabled"
                    v-model="robocallReduction.config.coordinator_primary_enabled"
                    class="form-check-input"
                    type="checkbox"
                    aria-labelledby="coordinator_primary_enabled">
                  <label class="form-check-label" for="coordinator_primary_enabled">Enabled</label>
                </div>
                <div class="row">
                  <TextInput v-model="robocallReduction.config.primary_stop_duration"
                    name="primary_stop_duration"
                    type="number"
                    label="Primary Stop Duration"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                  <TextInput v-model="robocallReduction.config.primary_resend_duration"
                    name="primary_resend_duration"
                    type="number"
                    label="Primary Resend Interval"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                </div>
              </div>

              <div class="notification-box">
                <h5>Delayed Email Notification</h5>
                <div class="form-check form-check-inline mb-3">
                  <input id="delayed_email_enabled"
                    v-model="robocallReduction.config.delayed_email_enabled"
                    class="form-check-input"
                    type="checkbox"
                    aria-labelledby="delayed_email_enabled">
                  <label class="form-check-label" for="delayed_email_enabled">Enabled</label>
                </div>
                <div class="row">
                  <TextInput v-model="robocallReduction.config.delayed_email_threshold"
                    name="delayed_email_threshold"
                    type="number"
                    label="Delayed email threshold"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                </div>
              </div>

              <div class="notification-box">
                <h5>AOC Response Delay Notification</h5>
                <div class="form-check form-check-inline mb-3">
                  <input id="aoc_response_delay_enabled"
                    v-model="robocallReduction.config.aoc_response_delay_enabled"
                    class="form-check-input"
                    type="checkbox"
                    aria-labelledby="aoc_response_delay_enabled">
                  <label class="form-check-label" for="aoc_response_delay_enabled">Enabled</label>
                </div>
                <!-- <SingleSelect v-model="robocallReduction.config.regular_delay_algorithm"
                  name="regular_delay_algorithm"
                  label="Regular Delay Algorithm"
                  :options="delayAlgorithmOptions"
                  col-style="form-group-standard-column"
                /> -->
                <div class="row">
                  <TextInput v-model="robocallReduction.config.aoc_regular_offers_response_delay"
                    name="aoc_regular_offers_response_delay"
                    type="number"
                    label="Regular Offers Response Delay"
                    rules="required|min_value:0"
                    col-style="form-group-standard-column"
                  />
                  <TextInput v-model="robocallReduction.config.aoc_expedited_offers_response_delay"
                    name="aoc_expedited_offers_response_delay"
                    type="number"
                    label="Expedited Offers Response Delay"
                    rules="required|min_value:0"
                    col-style="form-group-standard-column"
                  />
                </div>
              </div>

              <div class="notification-box">
                <h5>Coordinator Response Delay Notification</h5>
                <div class="form-check form-check-inline mb-3">
                  <input id="coordinator_response_delay_enabled"
                    v-model="robocallReduction.config.coordinator_response_delay_enabled"
                    class="form-check-input"
                    type="checkbox"
                    aria-labelledby="coordinator_response_delay_enabled">
                  <label class="form-check-label" for="coordinator_response_delay_enabled">Enabled</label>
                </div>
                <div class="row">
                  <TextInput v-model="robocallReduction.config.regular_offers_response_delay"
                    name="regular_offers_response_delay"
                    type="number"
                    label="Regular Offers Response Delay"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                  <TextInput v-model="robocallReduction.config.expedited_offers_response_delay"
                    name="expedited_offers_response_delay"
                    type="number"
                    label="Expedited Offers Response Delay"
                    rules="required|min_value:1"
                    col-style="form-group-standard-column"
                  />
                </div>
              </div>
              </div>
              <!-- save controls -->
              <div class="inline-row">
              <ActionToolbar :component-state="currentState" 
                success-message="Successfully updated robocall reduction!"
                primary-button-text="Save"
                :secondary-enabled="false"
                :error-message="formError">
              </ActionToolbar>
                <p class="small">
                  Page last updated by {{robocallReduction.user_who_last_updated_page}} at {{formatDateTimeET(robocallReduction.updated_at)}} ET
                </p>
              </div>
            </VeeForm>
          </template>
        </SubSection>
        </div>
      </template>
    </SubSection>
    </template>
  </CardSection>
</template>

<script>
import RobocallReductionState from "@/src/components/admin-area/application-settings/robocall-reductions/_robocallReductionState.vue"
import CardSection from "@/src/components/shared/CardSection.vue";
import SubSection from "@/src/components/shared/SubSection.vue";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import TextInput from "@/src/components/shared/FormComponents/TextInput.vue";
import { Form as VeeForm } from 'vee-validate';
import { useRobocallReductionsStore } from '@/src/stores/robocall_reductions';
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import SingleSelect from "@/src/components/shared/FormComponents/SingleSelect.vue";
import {format, toZonedTime} from "date-fns-tz";
import { formatDateTimeET } from "@/src/date-helpers";
import {robocallReductionSubsectionNavMixin} from "@/src/components/admin-area/application-settings/robocall-reductions/robocallReductionSubsectionNavMixin";
import { pageMixin } from "@/src/mixins/pageMixin";

/**
 * The component handles both the new and edit pages for Application Settings */
export default {
  components: {
    CardSection,
    SubSection,
    ActionToolbar,
    TextInput,
    SingleSelect,
    RobocallReductionState,
    VeeForm,
  },
  mixins: [ savableStateMixin, robocallReductionSubsectionNavMixin, pageMixin ],
  setup() {
    const robocallReductionsStore = useRobocallReductionsStore();
    return { robocallReductionsStore };
  },
  data() {
    return {
      robocallReduction: {config: {}},
      type: null,
      formatDateTimeET: formatDateTimeET,
      delayAlgorithmOptions: [
        { code: '1', value: 'Algorithm 1' },
      ],
    }
  },
  computed: {
    isEnabled() {
      return this.robocallReduction.active
    },
  },
  watch: { 
    '$route.params.id': {
      handler: function() {
        this.buildRobocallReduction();
      }
    }
  },
  async mounted() {
    let url = window.location.pathname.split('/')
    this.type = url[url.length-(this.$route.params.id ? 3 : 2)]
    this.buildRobocallReduction();
  },
   methods: {
    async buildRobocallReduction() {
      try {
        this.setSavableStateLoading();
        // on edit
        const response = await this.robocallReductionsStore.loadRobocallReduction(this.$route.params.id, this.type);
        this.setRobocallReduction(response);
        this.setSavableStateIdle();
      } catch(error) {
        this.handleMajorError(error);
      }
    },
    async submitRobocallReduction() {
      const payload = {
        config: this.robocallReduction.config,
        active: this.robocallReduction.active,
      }
      try {
        this.setSavableStateProcessing();
        let response;
        response = await this.robocallReductionsStore.updateRobocallReduction(payload);
        this.setRobocallReduction(response);
        this.setSavableStateSuccess();
      } catch(error) {
        this.handleFormError(error);
      }
    },

    reload(record) {
      this.currentState = this.SaveStates.Blank;
      this.setRobocallReduction(record)
    },

    setRobocallReduction(record) {
      this.robocallReduction = {
        id: record.id,
        configCategory: record.config_category,
        config: record.config,
        active: record.active,
        status_changed_by_name: record.status_changed_by ? record.status_changed_by.full_name : 'N/A',
        user_who_last_updated_page: record.updated_by.full_name,
        last_status_change_time: record.config.status_changed_date,
        updated_at: record.updated_at,
        last_incoming_email_date_time: record.last_incoming_email_date_time,
        last_incoming_call_date_time: record.last_incoming_call_date_time
      }
    },
  }
}
</script>

<style scoped>
.notification-box {
  border: 1px solid #d0d2d5;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
}

.notification-box h5 {
  margin-bottom: 1rem;
}
</style>
